module.exports = __webpack_public_path__ + "img/logo6.66262b06.svg";